import React, { useState } from "react";
import Card from "components/card";
import CenteredSlideshow, { Slide } from "components/centered-slideshow";
import Modal from "components/modal";
import { formatDateAndTime, formatDate } from "helpers/formatDate";
import { ImageSwiper, NextArrow, PrevArrow, ModalContent } from "components/events/helpers";
import DateCard from "components/date-card";
import ArrowRightYellow from "images/arrow-right-yellow.png";
import Link from "helpers/link";
import "./styles.scss";

const centeredSlideshowConfig = (slidesPerView) => ({
  breakpoints: {
    300: {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 14,
    },
    768: {
        slidesPerView: (slidesPerView - 1 < 1) ? 1 : slidesPerView - 1,
        centeredSlides: false,
    },
    1024: {
        slidesPerView: slidesPerView,
        centeredSlides: false,
    },
  },
  slidesPerView: slidesPerView,
})

const Events = ({ data }) => {
  const { listOfEvents, numberPerSlides } = data;

  const [modal, setModal] = useState({ isOpen: false, currentEventIndex: null, currentSlide: 0, currentEvent: "" })

  const [slideshowSlider, setSlideshowSlider] = useState(undefined);

  if (!listOfEvents?.length || !listOfEvents) return <></>;

  const slideshowModalImages = listOfEvents[modal.currentEventIndex]?.images;

  const modalSettings = {
    afterChange: (current) => setModal((prevState) => ({ ...prevState, currentSlide: current }))
  }

  const eventSectionIsForUpcomingEvents = listOfEvents.map((item) => item._type === "upcomingEvent").every((value) => value === true);

  const handleOpenModal = (eventIndex, clickedImageIndex) => {
    setModal((prevState) => ({ ...prevState, isOpen: true, currentEventIndex: eventIndex, currentSlide: clickedImageIndex }));
  }

  return (
    <>
      {(modal.isOpen) && (
        <Modal
          onClose={() => setModal((prevState) => ({ ...prevState, isOpen: false, currentEventIndex: null, currentSlide: 0 })) }
          beforeChildren={
            <PrevArrow 
              className={modal.currentSlide === 0 ? "invisible" : "visible"} 
              onClick={() => slideshowSlider?.slickPrev()} 
            />
          }
          afterChildren={
            <NextArrow
              className={modal.currentSlide === slideshowModalImages?.length - 1 ? "invisible" : "visible"}
              onClick={() => slideshowSlider?.slickNext()} 
            />
          }
          contentClassName="events-modal-slideshow"
          backgroundClassName="bg-[#707070] bg-opacity-100"
        >
          <ModalContent
            images={slideshowModalImages} 
            setSlideshowSlider={setSlideshowSlider}
            initialSlide={modal.currentSlide}
            settings={modalSettings}
          />
        </Modal>
      )}
      <div className="bg-white events">
        <div className="mb-8 container">
          <div>
            <h2 className="header mb-2.5">{data.title}</h2>
            <p className="text-gray-700 font-montserrat font-medium text-lg sm:text-base">{data.description}</p>
          </div>
        </div>
        <div className="overflow-hidden container !max-w-[calc(100%-(100%-1280px)/2)] !mr-0 !pr-0 sm:ml-0 sm:pl-0">
          <CenteredSlideshow extraConfig={centeredSlideshowConfig(numberPerSlides || 1)}>
              {listOfEvents.map((item, index) => {
                const { name, description, date, author, authorIcon, images, _key, _type } = item;

                if (_type === "genericEvent") {
                  return (
                    <Slide key={_key}>
                      <Card
                          authorImage={authorIcon.src}
                          author={author}
                          date={formatDate(date)}
                          title={name}
                          description={description}
                          Image={<ImageSwiper images={images} onOpenModal={handleOpenModal} eventIndex={index} modalState={modal} />}
                        />
                    </Slide>
                  ) 
                }

                if (_type === "upcomingEvent") {
                  const { title, startTime, endTime, location } = item;
                  const { day: startDay, month, time: timeStart } = formatDateAndTime(startTime);
                  const { time: timeEnd } = formatDateAndTime(endTime);

                  return (
                    <Slide>
                      <div className="flex w-full items-center gap-6 h-full">
                        <DateCard heading={startDay} subheading={month} description={title} date={`${timeStart} - ${timeEnd}, ${location}`} />
                        {index !== listOfEvents.length - 1 && <img src={ArrowRightYellow} alt="Next date to the right" className="w-6 h-6" />}
                      </div>
                    </Slide>
                  )
                }
                })}
          </CenteredSlideshow>
        </div>
        {eventSectionIsForUpcomingEvents && (
          <Link to="/horses" className="btn btn-primary w-fit mx-auto mt-16 !font-montserrat !font-normal !text-base"> Become an Owner </Link>
        )}
      </div>
    </>
  );
};

export default Events;
